export default "__VITE_ASSET__kcfHNrdW__"